import BaseAction from "./BaseAction";
import SessionalPositionsReducer from "../reducers/SessionalPositionsReducer";

class SessionalPositionsAction extends BaseAction {}

const action = new SessionalPositionsAction(SessionalPositionsReducer);

export default action;
